// Zentraler fetch-Wrapper fuer das Finanzmodul-Backend, analog der lokalen API-Konstante in
// App.js - bewusst kein axios/react-query (im Rest der App unbenutzt, siehe Architekturplan
// Abschnitt 8, C:\Users\e.lauria\.claude\plans\eager-greeting-crystal.md).
const API = ["localhost", "127.0.0.1"].includes(window.location.hostname)
  ? "http://localhost:8000"
  : `${window.location.protocol}//${window.location.hostname}`;

async function anfrage(pfad, { methode = "GET", body, benutzerId, params } = {}) {
  const url = new URL(`${API}/finanzen${pfad}`);
  if (benutzerId) url.searchParams.set("benutzer_id", benutzerId);
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") url.searchParams.set(k, v);
    });
  }
  const optionen = { method: methode, headers: {} };
  if (body instanceof FormData) {
    optionen.body = body;
  } else if (body !== undefined) {
    optionen.headers["Content-Type"] = "application/json";
    optionen.body = JSON.stringify(body);
  }
  const res = await fetch(url, optionen);
  const daten = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(daten.detail || `Fehler ${res.status}`);
  return daten;
}

export const finanzenApi = {
  status: (benutzerId) => anfrage("/status", { benutzerId }),

  // Dokumentenarchiv der Steuerkanzlei (Phase 1, nur lesend)
  dokumenteListe: (benutzerId, doktyp) => anfrage("/dokumente", { benutzerId, params: { doktyp } }),
  dokumenteIntegritaet: (benutzerId) => anfrage("/dokumente/integritaet", { benutzerId }),

  // SKR03-Kontenplan (Phase 2) - Recht finanzen_kontenplan
  kontenplanListe: (benutzerId, params) => anfrage("/kontenplan", { benutzerId, params }),
  kontenplanZusammenfassung: (benutzerId) => anfrage("/kontenplan/zusammenfassung", { benutzerId }),
  kontenplanBearbeiten: (benutzerId, id, daten) => anfrage(`/kontenplan/${id}`, { methode: "PATCH", benutzerId, body: daten }),
  kontenplanStatus: (benutzerId, id, status) => anfrage(`/kontenplan/${id}/status`, { methode: "POST", benutzerId, body: { status } }),
  kontenplanHinweisErledigt: (benutzerId, id) => anfrage(`/kontenplan/hinweise/${id}/erledigt`, { methode: "POST", benutzerId }),
  kontenplanHinweise: (benutzerId) => anfrage("/kontenplan/hinweise", { benutzerId }),
  kontenplanExport: async () => {
    const res = await fetch(`${API}/finanzen/kontenplan/export.csv`);
    if (!res.ok) {
      const daten = await res.json().catch(() => ({}));
      throw new Error(daten.detail || `Fehler ${res.status}`);
    }
    return res.blob();
  },
  dokumentBlob: async (id, art) => {
    const res = await fetch(`${API}/finanzen/dokumente/${id}/${art === "eml" ? "eml" : "datei"}`);
    if (!res.ok) {
      const daten = await res.json().catch(() => ({}));
      throw new Error(daten.detail || `Fehler ${res.status}`);
    }
    return res.blob();
  },

  kategorienListe: (benutzerId) => anfrage("/kategorien", { benutzerId }),
  kategorieErstellen: (benutzerId, daten) => anfrage("/kategorien", { methode: "POST", benutzerId, body: daten }),
  kategorieBearbeiten: (benutzerId, id, daten) => anfrage(`/kategorien/${id}`, { methode: "PATCH", benutzerId, body: daten }),
  kategorieLoeschen: (benutzerId, id) => anfrage(`/kategorien/${id}`, { methode: "DELETE", benutzerId }),

  regelnListe: (benutzerId) => anfrage("/regeln", { benutzerId }),
  regelErstellen: (benutzerId, daten) => anfrage("/regeln", { methode: "POST", benutzerId, body: daten }),
  regelBearbeiten: (benutzerId, id, daten) => anfrage(`/regeln/${id}`, { methode: "PATCH", benutzerId, body: daten }),
  regelAktivSetzen: (benutzerId, id, aktiv) => anfrage(`/regeln/${id}/aktiv`, { methode: "PATCH", benutzerId, body: { aktiv } }),
  regelLoeschen: (benutzerId, id) => anfrage(`/regeln/${id}`, { methode: "DELETE", benutzerId }),

  bankumsaetzeListe: (benutzerId, params) => anfrage("/bankumsaetze", { benutzerId, params }),
  kontostand: (benutzerId, datum) => anfrage("/kontostand", { benutzerId, params: { datum } }),
  bankumsatzDetail: (benutzerId, id) => anfrage(`/bankumsaetze/${id}`, { benutzerId }),
  bankumsatzBearbeiten: (benutzerId, id, daten) => anfrage(`/bankumsaetze/${id}`, { methode: "PATCH", benutzerId, body: daten }),
  bankumsaetzeBulkBearbeiten: (benutzerId, daten) => anfrage("/bankumsaetze/bulk", { methode: "PATCH", benutzerId, body: daten }),
  bankumsatzRechnungVerknuepfen: (benutzerId, id, rechnungId) => anfrage(`/bankumsaetze/${id}/rechnung-verknuepfen`, { methode: "POST", benutzerId, body: { rechnung_id: rechnungId } }),

  // Liegt unter /rechnungen, nicht /finanzen - eigener Aufruf statt ueber anfrage() (das den
  // Pfad fest mit /finanzen prefixt), nur fuer die "mit Rechnung verknuepfen"-Suche im
  // Bankumsatz-Detail gebraucht.
  rechnungenListe: () => fetch(`${API}/rechnungen/`).then(r => r.json()),

  wiederkehrendKandidaten: (benutzerId) => anfrage("/wiederkehrend/kandidaten", { benutzerId }),
  wiederkehrendBestaetigen: (benutzerId, daten) => anfrage("/wiederkehrende-zahlungen", { methode: "POST", benutzerId, body: daten }),
  wiederkehrendeZahlungenListe: (benutzerId) => anfrage("/wiederkehrende-zahlungen", { benutzerId }),
  wiederkehrendIgnorieren: (benutzerId, id) => anfrage(`/wiederkehrende-zahlungen/${id}`, { methode: "DELETE", benutzerId }),

  uebersicht: (benutzerId, params) => anfrage("/uebersicht", { benutzerId, params }),
  aufgaben: (benutzerId) => anfrage("/aufgaben", { benutzerId }),

  importVorschau: (benutzerId, datei) => {
    const form = new FormData();
    form.append("datei", datei);
    return anfrage("/imports/vorschau", { methode: "POST", benutzerId, body: form });
  },
  importAusfuehren: (benutzerId, datei) => {
    const form = new FormData();
    form.append("datei", datei);
    return anfrage("/imports", { methode: "POST", benutzerId, body: form });
  },
  importListe: (benutzerId, params) => anfrage("/imports", { benutzerId, params }),
  importDetail: (benutzerId, id) => anfrage(`/imports/${id}`, { benutzerId }),

  bwaVorschau: (benutzerId, datei) => {
    const form = new FormData();
    form.append("datei", datei);
    return anfrage("/bwa/vorschau", { methode: "POST", benutzerId, body: form });
  },
  bwaImportieren: (benutzerId, datei, ueberschreiben) => {
    const form = new FormData();
    form.append("datei", datei);
    return anfrage("/bwa", { methode: "POST", benutzerId, params: { ueberschreiben: ueberschreiben || undefined }, body: form });
  },
  bwaListe: (benutzerId) => anfrage("/bwa", { benutzerId }),
  bwaEmailSync: (benutzerId) => anfrage("/bwa/email-sync", { methode: "POST", benutzerId }),
  bwaDetail: (benutzerId, id) => anfrage(`/bwa/${id}`, { benutzerId }),
  bwaTrend: (benutzerId) => anfrage("/bwa/trend", { benutzerId }),
  bwaLoeschen: (benutzerId, id) => anfrage(`/bwa/${id}`, { methode: "DELETE", benutzerId }),

  anlagevermoegenListe: (benutzerId) => anfrage("/anlagevermoegen", { benutzerId }),
  anlagegutAnlegen: (benutzerId, daten) => anfrage("/anlagevermoegen", { methode: "POST", benutzerId, body: daten }),
  anlagegutBearbeiten: (benutzerId, id, daten) => anfrage(`/anlagevermoegen/${id}`, { methode: "PUT", benutzerId, body: daten }),
  anlagegutAbgangSetzen: (benutzerId, id, abgangsdatum) => anfrage(`/anlagevermoegen/${id}/abgang`, { methode: "POST", benutzerId, body: { abgangsdatum } }),
  anlagegutLoeschen: (benutzerId, id) => anfrage(`/anlagevermoegen/${id}`, { methode: "DELETE", benutzerId }),
  schaetzungBwa: (benutzerId, monat, jahr) => anfrage("/schaetzung-bwa", { benutzerId, params: { monat, jahr } }),

  ustvaVorschau: (benutzerId, datei) => {
    const form = new FormData();
    form.append("datei", datei);
    return anfrage("/ustva/vorschau", { methode: "POST", benutzerId, body: form });
  },
  ustvaImportieren: (benutzerId, datei, ueberschreiben) => {
    const form = new FormData();
    form.append("datei", datei);
    return anfrage("/ustva", { methode: "POST", benutzerId, params: { ueberschreiben: ueberschreiben || undefined }, body: form });
  },
  ustvaListe: (benutzerId) => anfrage("/ustva", { benutzerId }),
  ustvaLoeschen: (benutzerId, id) => anfrage(`/ustva/${id}`, { methode: "DELETE", benutzerId }),
};
